import _ from 'underscore';

/**
 * DO NOT FORGET THIS IS USED IN TWO PLACES
 */
export default function ThumbnailsController(
  $q,
  $scope,
  CreativeService,
  ImageService,
  MixpanelService
) {
  var vm = this;

  vm.bounds = {};
  vm.uploading = false;
  vm.originalUrl = $scope.originalUrl;
  vm.originalFilename = null;
  vm.croppedImageUrl = null;
  vm.errors = {};
  vm.uploadImageFile = uploadImageFile;
  vm.crop = crop;
  vm.ratio =
    CreativeService.creative.action === 'scroller' ? 'oneToThree' : 'free';
  vm.desktopDimensions = desktopDimensions;
  vm.getOriginalUrl = getOriginalUrl;
  vm.setRatio = setRatio;
  vm.showCropControls = showCropControls;
  vm.reset = reset;
  vm.rotate = rotate;
  vm.rotating = false;
  vm.rotatedAngle = 0;
  vm.loading = false;
  vm.progressPercentage = 0;

  vm.RATIOS = {
    oneToOne: 1,
    oneNineOneToOne: 1.911 / 1,
    fourToThree: 4 / 3,
    oneToThree: 1 / 3
  };
  vm.DESKTOP_PREVIEW_DIMENSIONS = { width: 320, height: 240 };
  vm.MOBILE_DIMENSIONS = { width: 320, height: 240 };
  vm.MOBILE_PREVIEW_DIMENSIONS = { width: 100, height: 75 };
  vm.cropWidth = vm.MOBILE_DIMENSIONS.width;
  vm.cropHeight = vm.MOBILE_DIMENSIONS.height;

  $scope.$watchGroup(
    [
      function() {
        return vm.bounds.top;
      },
      function() {
        return vm.bounds.bottom;
      },
      function() {
        return vm.bounds.left;
      },
      function() {
        return vm.bounds.right;
      }
    ],
    _.debounce(setCropDimensions, 100)
  );

  function setCropDimensions() {
    if (
      vm.bounds.top === undefined ||
      vm.bounds.bottom === undefined ||
      vm.bounds.left === undefined ||
      vm.bounds.right === undefined
    ) {
      return;
    }

    vm.cropWidth = vm.bounds.right - vm.bounds.left;
    vm.cropHeight = vm.bounds.top - vm.bounds.bottom;
  }

  function getOriginalUrl() {
    if (!vm.originalUrl) {
      return null;
    }
    return vm.originalUrl + '?or=' + vm.rotatedAngle;
  }

  function reset(options) {
    options = options || { clearOriginalUrl: true };

    if (options.clearOriginalUrl) {
      vm.originalUrl = null;
    }
    vm.rotatedAngle = 0;
    vm.croppedImageUrl = null;
    vm.desktopDownloadUrl = null;
    vm.desktopPreviewUrl = null;
    vm.mobileDownloadUrl = null;
    vm.mobilePreviewUrl = null;
  }

  function rotate() {
    vm.rotatedAngle = (vm.rotatedAngle + 90) % 360;
  }

  function setRatio(ratio) {
    vm.ratio = ratio;
    vm.bounds = {};
  }

  function desktopDimensions() {
    if (vm.ratio === 'free') {
      return { width: vm.cropWidth, height: vm.cropHeight };
    } else {
      return { width: 1200, height: 1200 * (1 / vm.RATIOS[vm.ratio]) };
    }
  }

  function setDefaultError() {
    vm.loading = false;
    vm.errors = { default: 'Something went wrong. Please try again.' };
  }

  function clearErrors() {
    vm.errors = {};
  }

  function showCropControls() {
    return !!getOriginalUrl();
  }

  function crop() {
    vm.croppedImageUrl = null;
    MixpanelService.track('Image Cropped');

    if (vm.loading) {
      return $q.resolve(); // shouldn't be doing this over and over...
    }

    vm.loading = true;

    return ImageService.uploadDataUrl('/thumbnails', vm.rawCroppedImage)
      .then(function(croppedImageResponse) {
        vm.croppedImageUrl = croppedImageResponse.data.thumbnailUrl;

        vm.desktopDownloadUrl =
          vm.croppedImageUrl +
          '?fmt=jpg' +
          '&dl=' +
          vm.originalFilename +
          '-desktop.jpg';

        vm.desktopPreviewUrl =
          vm.croppedImageUrl +
          '?fmt=jpg' +
          urlParamsFor(vm.DESKTOP_PREVIEW_DIMENSIONS);

        vm.mobileDownloadUrl =
          vm.croppedImageUrl +
          '?fmt=jpg' +
          '&dl=' +
          vm.originalFilename +
          '-mobile.jpg' +
          urlParamsFor(vm.MOBILE_DIMENSIONS);

        vm.mobilePreviewUrl =
          vm.croppedImageUrl +
          '?fmt=jpg' +
          urlParamsFor(vm.MOBILE_PREVIEW_DIMENSIONS);

        vm.loading = false;
      })
      .catch(setDefaultError);
  }

  function urlParamsFor(dimensions) {
    return '&w=' + dimensions.width + '&h=' + dimensions.height;
  }

  function uploadImageFile(files, closeModalCallback) {
    reset({ clearOriginalUrl: false });

    if (!(files && files[0])) {
      setDefaultError();
      return $q.resolve();
    }

    vm.uploading = true;
    vm.originalFilename = files[0].name;

    MixpanelService.track('Image Uploaded');

    clearErrors();

    return ImageService.uploadFile('/thumbnails', files[0])
      .then(
        resp => {
          uploadSuccess(resp);
          // Don't allow cropping gifs, just skip the whole crop UX stat
          if (vm.contentType === 'image/gif') {
            CreativeService.creative.thumbnailUrl = resp.data.thumbnailUrl;

            // set gif on slide, this same code also runs after the image
            // is croppepd in ThumbnailModalController
            if (
              $scope.slideIndex !== undefined &&
              resp.data.thumbnailUrl !== undefined
            ) {
              $scope.callback($scope.slideIndex, resp.data.thumbnailUrl);
            }

            closeModalCallback();
          }
        },
        uploadError,
        evt => {
          vm.progressPercentage = parseInt((100.0 * evt.loaded) / evt.total);
        }
      )
      .finally(uploadDone);
  }

  function uploadSuccess(response) {
    vm.originalUrl = response.data.thumbnailUrl;
    vm.originalFilename = response.data.filename;
    vm.contentType = response.data.contentType;
  }

  function uploadError(err) {
    if (err && err.data.errors) {
      vm.errors = err.data.errors;
    } else {
      setDefaultError();
    }

    return $q.reject();
  }

  function uploadDone() {
    vm.uploading = false;
  }
}

ThumbnailsController.$inject = [
  '$q',
  '$scope',
  'CreativeService',
  'ImageService',
  'MixpanelService'
];
